import React, { useState } from 'react';

const DetailsStep = ({ onComplete, onBack, initialAnswers }) => {
  const [additionalNotes, setAdditionalNotes] = useState(
    initialAnswers?.additionalNotes || ''
  );
  const [age, setAge] = useState(
    initialAnswers?.age || ''
  );
  const [genderIdentity, setGenderIdentity] = useState(
    initialAnswers?.genderIdentity || ''
  );

  const handleNext = () => {
    onComplete({ 
      additionalNotes: additionalNotes.trim(),
      age: age.trim(),
      genderIdentity: genderIdentity.trim()
    });
  };

  const handleKeyPress = (e) => {
    // Allow Enter to submit if Shift is not pressed
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleNext();
    }
  };

  return (
    <div className="quiz-step">
      <h2>Final Details</h2>
      <p>Help us ensure your variations are perfect for you and follow competition guidelines.</p>
      
      <div style={{ marginBottom: '2rem' }}>
        <label htmlFor="additional-notes" style={{ 
          display: 'block', 
          marginBottom: '0.5rem', 
          fontWeight: '600',
          color: 'var(--text-primary)'
        }}>
          Anything else you'd like us to know about your dancing?
        </label>
        <textarea
          id="additional-notes"
          className="text-input"
          placeholder="e.g., 'I love dramatic characters but struggle with fast footwork' or 'I've always dreamed of dancing Aurora' or 'I'm working on my port de bras'"
          value={additionalNotes}
          onChange={(e) => setAdditionalNotes(e.target.value)}
          onKeyPress={handleKeyPress}
          rows={3}
          maxLength={300}
          style={{ resize: 'vertical', minHeight: '80px' }}
        />
        <div style={{ textAlign: 'right', marginTop: '0.25rem', color: 'var(--soft-gray)', fontSize: '0.8rem' }}>
          {additionalNotes.length}/300 characters
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginBottom: '2rem' }}>
        <div>
          <label htmlFor="age" style={{ 
            display: 'block', 
            marginBottom: '0.5rem', 
            fontWeight: '600',
            color: 'var(--text-primary)'
          }}>
            Age <span style={{ color: 'var(--soft-gray)', fontWeight: '400' }}>(optional)</span>
          </label>
          <input
            id="age"
            type="text"
            className="text-input"
            placeholder="e.g., 16 or March 2008"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            style={{ width: '100%', padding: '0.75rem' }}
          />
        </div>

        <div>
          <label htmlFor="gender" style={{ 
            display: 'block', 
            marginBottom: '0.5rem', 
            fontWeight: '600',
            color: 'var(--text-primary)'
          }}>
            Gender Identity <span style={{ color: 'var(--soft-gray)', fontWeight: '400' }}>(optional)</span>
          </label>
          <input
            id="gender"
            type="text"
            className="text-input"
            placeholder="e.g., Female, Male, Non-binary"
            value={genderIdentity}
            onChange={(e) => setGenderIdentity(e.target.value)}
            style={{ width: '100%', padding: '0.75rem' }}
          />
        </div>
      </div>

      <div style={{ textAlign: 'center', marginBottom: '2rem', padding: '1rem', backgroundColor: 'var(--light-bg)', borderRadius: '8px' }}>
        <div style={{ color: 'var(--soft-gray)', fontSize: '0.9rem', fontStyle: 'italic' }}>
          💡 <strong>Optional fields help ensure:</strong> Age-appropriate variations and adherence to competition guidelines for gender categories
        </div>
      </div>

      <div className="quiz-buttons">
        <button className="btn-back" onClick={onBack}>
          ← Back
        </button>
        <button 
          className="btn-next" 
          onClick={handleNext}
        >
          Get My Results! ✨
        </button>
      </div>
    </div>
  );
};

export default DetailsStep; 